import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconXmarkSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.707 5.293 6 4.586 4.586 6l.707.707L10.586 12l-5.293 5.293-.707.707L6 19.414l.707-.707L12 13.414l5.293 5.293.707.707L19.414 18l-.707-.707L13.414 12l5.293-5.293.707-.707L18 4.586l-.707.707L12 10.586 6.707 5.293Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconXmarkSharp);
export default Memo;
